// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"im-NY","header":"xH7Tq","body":"_2FVKc","button":"_29lgO","custom":"ZdglE","title":"_3Hp3z","description":"cRMvf","ccMessage":"_1XhYi","icon":"_3io_R"};